import styled from 'styled-components';
import { ThemeType } from '../../types/Theme';

const LockedIconContainer = styled.div<{ theme: ThemeType, mensagem: string, style?: React.CSSProperties, className?: string, width?: string, showPopover?: boolean }>`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    width: ${({ width }) => width || 'auto'};
    svg{
        height: ${({ width }) => width || 'auto'};
        width: ${({ width }) => width || 'auto'};
       path{
            fill: ${(props) => props.theme.colors.tertiary};
       }
    }
    
    &::after {
        content: "${({ mensagem }) => mensagem}";
        pointer-events: none;
        opacity: 0;
        transition: opacity 0.3s ease-in-out;
        position: absolute;
        text-align: center;
        z-index: 3;
        bottom: 4.5rem;
        color: ${(props) => props.theme.colors.tertiary};
        background-color: ${(props) => props.theme.colors.modal};
        padding: 1rem 3rem;
        white-space: nowrap;
        border-radius: 5rem;
        display: ${({ mensagem }) => mensagem ? 'block' : 'none'};
        filter: drop-shadow(0px 2px 2px #626262);
        font-weight: 400;
    }
    
    @media (max-width: 1024px) {
        &::after {
            white-space: normal;
            width: auto;
            min-width: 35rem;
            left: 50%;
            transform: translateX(-50%);
            padding: 2rem;
        }
        &::before {
            left: 50%;
            transform: translateX(-50%) rotate(45deg);
        }
    }
    
    &:hover {
        &::after {
            opacity: ${({ mensagem }) => mensagem ? '1' : '0'};
        }
        &::before {
            opacity: ${({ mensagem }) => mensagem ? '1' : '0'};
        }
    }
`;

export {
    LockedIconContainer,
};
